import { Plus, Trash2 } from "lucide-react";
import { fmtEuro } from "@/lib/api";

const cell = "h-10 w-full rounded-lg border border-slate-200 px-2.5 text-sm outline-none focus:border-emerald-500";

// Ogni voce ha una chiave stabile lato client (non salvata) per il rendering React
export const withKey = (item) => ({ ...item, _key: item._key || crypto.randomUUID() });
export const newItem = () => withKey({ description: "", qty: 1, unit_price: 0 });

export const QuoteItems = ({ items, onChange }) => {
  const patch = (i, k, v) => onChange(items.map((it, j) => (j === i ? { ...it, [k]: v } : it)));
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-5">
      <p className="mb-3 text-sm font-semibold text-slate-900">Voci del preventivo</p>
      <div className="space-y-2">
        <div className="hidden grid-cols-12 gap-2 text-xs uppercase tracking-wider text-slate-400 sm:grid">
          <span className="col-span-6">Descrizione</span><span className="col-span-2">Q.tà</span><span className="col-span-2">Prezzo €</span><span className="col-span-2 text-right">Totale</span>
        </div>
        {items.map((it, i) => (
          <div key={it._key} data-testid={`quote-item-row-${i}`} className="grid grid-cols-12 items-center gap-2">
            <input data-testid={`quote-item-description-${i}`} className={`${cell} col-span-12 sm:col-span-6`} placeholder="Descrizione" value={it.description} onChange={(e) => patch(i, "description", e.target.value)} />
            <input data-testid={`quote-item-qty-${i}`} type="number" min="0" className={`${cell} col-span-3 sm:col-span-2`} value={it.qty} onChange={(e) => patch(i, "qty", e.target.value)} />
            <input data-testid={`quote-item-price-${i}`} type="number" min="0" step="0.01" className={`${cell} col-span-4 sm:col-span-2`} value={it.unit_price} onChange={(e) => patch(i, "unit_price", e.target.value)} />
            <span className="col-span-4 text-right text-sm font-medium sm:col-span-1">{fmtEuro(Number(it.qty || 0) * Number(it.unit_price || 0))}</span>
            <button data-testid={`quote-item-remove-${i}`} disabled={items.length === 1} onClick={() => onChange(items.filter((_, j) => j !== i))}
              className="col-span-1 grid place-items-center rounded-lg p-2 text-slate-400 hover:text-rose-600 disabled:opacity-30" aria-label="Rimuovi voce"><Trash2 className="h-4 w-4" /></button>
          </div>
        ))}
      </div>
      <button data-testid="quote-add-item-button" onClick={() => onChange([...items, newItem()])}
        className="mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-emerald-700 hover:text-emerald-800"><Plus className="h-4 w-4" /> Aggiungi voce</button>
    </div>
  );
};
